import React,{ useState} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Loader, Modal, Button  } from 'rsuite';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import * as actionsUser  from '../../../../app/actions/user';
import {generateAddressString}  from '../../../../app/common/services/vehicle.service';
import {BackIcon, CirclePlusIcon} from '../svg/iconsSvg';
import NewAddress from '../liabilityPolicy/NewAddress';
import CustomDrawer from '../../../pages/components/elements/CustomDrawer';


export const ProfileAddresses = ({onBack, style}) => {

    const dispatch = useDispatch();

    const userDetails = useSelector(state => state.userDetails);

    const [showDrawer, setShowDrawer] = useState({open: false, title: '', initData: {}});

    const [confirmDeleteModal, setConfirmDeleteModal] = useState({open: false, addressId: null});

    const [noDeleteModal, setNoDeleteModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const goBack = () => onBack(3);

    const closeDrawer = () => {
        setShowDrawer({open: false, title: '', initData: {}});
    }

    const closeModal = () => {
        setConfirmDeleteModal({open: false, addressId: null});
        setNoDeleteModal(false);
    }

    const editAddress = (event, addressId) => {
        event.stopPropagation();
        const address = userDetails?.userAddresses.find(obj => obj.addressId === addressId) || {};
        setShowDrawer({open: true, title: 'Промяна на адрес', initData: address, btnText: 'Промени'});
    }

    const askToDeleteAddress = (event, addressId) => {
        event.stopPropagation();
        const address = userDetails?.userAddresses.find(obj => obj.addressId === addressId);

        if(address.isUserAddress) {
            setNoDeleteModal(true);
        } else {

            setConfirmDeleteModal({open: true, addressId: addressId})
        }
    }

    const deleteAddress = async (event, addressId) => {
        event.stopPropagation();
        setConfirmDeleteModal({open: false, addressId: null})
        setLoading(true);
        await dispatch(actionsUser.deleteUserAddress(addressId));
        setLoading(false);
    }

    const addAddress = (event) => {
        event.stopPropagation();
        setShowDrawer({open: true, title: 'Добавяне на нов адрес', initData: {}});
    }

    const onNewAddressSubmit = async (newAddress, addressId) => {
        //console.log(newAddress, addressId);
        closeDrawer();
        setLoading(true);

        if(!addressId) {
            await dispatch(actionsUser.addAddress(newAddress))
        } else {
            const oldAddress = userDetails?.userAddresses.find(obj => obj.addressId === addressId) || {};
            const updatedAddress = {...oldAddress, ...newAddress};

            await dispatch(actionsUser.updateAddress(updatedAddress))
        }

        //await dispatch(actionsPolicy.addUserAddress(newAddress));

        setLoading(false);
    }

    const renderAddresses = () => {
        if(!userDetails.userAddresses) return;

        return userDetails.userAddresses.map((address, i) => {
            return <div className="profile-addresses" key={i+1}>
                <p style={address.isUserAddress ? {fontWeight: '600'} : {}}>{generateAddressString(address)}</p>
                <div className="icons" >
                    <EditOutlinedIcon className="icon" onClick={(event)=>editAddress(event, address?.addressId)} />
                    <DeleteForeverOutlinedIcon className="icon" onClick={(event)=>askToDeleteAddress(event, address?.addressId)} />
                </div>
            </div>
        });
    }

    return (
        <div className="steps_container" style={{...style, minHeight: '550px'}}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Адреси</h6>
            </div>
            <Divider style={{marginBottom: 0}}/>
            {renderAddresses()}
            <div className="steps_container-checkbox"  style={{cursor: 'pointer', marginTop: '1rem'}} onClick={addAddress}>
                <CirclePlusIcon size={22} />
                <h6 style={{ fontWeight: '500'}}>Добавяне на нов адрес</h6>
            </div>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

            {/* -----Custom Drawer---------- */}
            <CustomDrawer show={showDrawer.open} close={closeDrawer} headerText={showDrawer.title}>
                <NewAddress onSubmit={(data)=>onNewAddressSubmit(data, showDrawer.initData?.addressId)}  
                                initAddress={showDrawer.initData} noAddInfo={true} btnText={showDrawer.btnText}/>
            </CustomDrawer>
 
            {/* Modal */}
            <Modal size="xs" show={confirmDeleteModal.open} onHide={() => closeModal()} className="delivery-modal">
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{paddingBottom: '2rem'}}>
                    <p className="no-reg-data" style={{textAlign: 'center'}}>Искаш ли да изтриеш адреса?</p>    
                </Modal.Body>
                <Divider style={{margin: 0}} />
                <Modal.Footer className='delivery-modal-buttons'>
                    <Button appearance="subtle" onClick={() => closeModal()} >НЕ</Button>
                    <Button appearance="subtle" onClick={(ev) => deleteAddress(ev, confirmDeleteModal.addressId)} style={{marginLeft: 0}}>Да, изтрий</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal */}
            <Modal size="xs" show={noDeleteModal} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data">Този адрес не може да бъде изтрит, може само да бъде променян.</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ProfileAddresses;